import React, { useState, useEffect, useRef } from 'react';
// import { defineLordIconElement } from 'lord-icon-element';
import { ToastContainer } from 'react-toastify';
import { loadAnimation } from 'lottie-web';

import ScrollToTop from './Components/Common/ScrollToTop';
import './assets/scss/themes.scss';
import Route from './Routes';
import { IsValidChromeVersion } from './Components/Hooks/UserHooks';
import BrowserError from './pages/Errors/BrowserError';
import NewVersion from './Components/Common/NewVersion';

import { logoutAction } from './Store/callAPI/actions';
import { useMsal } from '@azure/msal-react';
import './i18n';
import NavigationListenerComponent from './Components/shared/NavigationListenerComponent';
import Index from './pages/Assessment/index';
import { clearStore } from './Store/commonStore/actions';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getTenantConfig } from './Components/Common/Util';
// register lottie and define custom element
// defineLordIconElement(loadAnimation);

function App() {
    const channel = new BroadcastChannel('my-channel');
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        channel.addEventListener('message', (e) => {
            if (e.data.action === 'login') {
                history.push('/dashboard');
            }
            if (e.data.action === 'logout') {
                dispatch(clearStore());
                history.replace('/login');
            }
            // if (e.data.action === 'fromDashboard') {
            //     window.open(e.data.link);
            // }
        });
    }, []);
    // useEffect(() => {
    //     document.body.dir = 'rtl';
    // });

    // if (!IsValidChromeVersion()) {
    //     return <BrowserError />;
    // }

    return (
        <React.Fragment>
            {/* <Index /> */}
            <ToastContainer />
            {/* <ScrollToTop /> */}
            {/* <NavigationListenerComponent /> */}
            <Route />
            {/* <NewVersion /> */}
        </React.Fragment>
    );
}

export default App;
